import { getArenas, patchArena, createArena } from '@fno/service/api/arenas.js'
import { getAppImplementation } from '@fno/service/api/tasks.js'
import { preFormMutator, preSaveMutator, getKeypath, preChangeMutator, nextHandler, previousHandler } from '@fno/route/tab/task/helpers.js'
import genericChange from '@fno/lib/form/generic-change.js'
import genericReset from '@fno/lib/form/generic-reset.js'
import genericSave from '@fno/lib/form/generic-save.js'
import arenaSchema from 'fanx-schema/resource/arena'
import template from './Venues.svelte'
import transformApiResponseToFormObject from '@fno/lib/transform-api-response-to-form-object.js'
import setContextOriginal from '@fno/lib/form/set-context-original.js'
import { get, set } from 'dot-prop'
import { getSchool } from '@fno/service/api/schools'

const page = {
    arenas: {
        type: Array,
        schema: arenaSchema,
        patch: arena => patchArena({ arena }),
        post: arena => createArena({ arena })
    }
}

const customPreFormMutator = ({ context }) => {
    const arenas = get(context, 'form.arenas', [])

    const arenasWithIsRewardable = arenas.map(arena => {
        arena.attributes.$isRewardable = arena.attributes.rewardable ? true : false
        arena.attributes.$attributesToPreserve = [ 'latitude', 'longitude' ]

        return arena
    })
    set(context, 'form.arenas', arenasWithIsRewardable)

    return preFormMutator({ context })
}

const customPreSaveMutator = ({ context }) => {
    const arenas = get(context, 'form.arenas', [])
    const arenasWithRewardable = arenas.map((arena) => {
        arena.attributes.rewardable = arena.attributes.$isRewardable
        delete arena.attributes.$isRewardable
        return arena
    })
    set(context, 'form.arenas', arenasWithRewardable)

    return preSaveMutator({ context })
}

export default (parent, stateRouter) => {
    const name = `${parent}.venues`

    stateRouter.addState({
        name,
        route: '/venues',
        template,
        data: {
            title: 'Venues | T.A.B.'
        },
        resolve: async (ignore, { schoolId }) => {
            const [ arenas, appImplementation, { school }] = await Promise.all([
                getArenas({ schoolId }),
                getAppImplementation({ schoolId }),
                getSchool({ schoolId })
            ])

            const kickOffPrep = get(appImplementation, 'attributes.steps', []).find(step => step.id === 'KICK_OFF_PREP')

            const rewardsEnabled =
                get(school, 'attributes.featuresEnabledInPortal.rewardsConfiguration', false) ||
                get(kickOffPrep, `usingRewards`)
                    ? true
                    : false

            const context = {
                context: {
                    form: {
                        arenas: arenas.map(arena => transformApiResponseToFormObject({ schema: arenaSchema, data: arena }))
                    },
                    view: {
                        rewardsEnabled
                    }
                }
            }
            
            return setContextOriginal(context, customPreFormMutator)
        },
        activate: ({ domApi: component, parameters: { schoolId } }) => {
            const save = genericSave({
                component,
                page,
                preSaveMutator: customPreSaveMutator,
                preFormMutator: customPreFormMutator
            })
            component.$on('nextStepClicked', nextHandler({
                stateRouter,
                component,
                save,
                schoolId,
                stepId: 'VENUES',
                nextId: () => 'teams'
            }))
            component.$on('previousStepClicked', previousHandler(stateRouter, 'appColors', schoolId))
            component.$on('save', save)
            component.$on('change', genericChange({ component, page, getKeypath, preChangeMutator }))
            component.$on('reset', genericReset({ component }))
        }
    })
}
